<template>
  <a  v-if="pdfSrc"
      :href="pdfSrc | imagePath('statement', 'default', true)"
      target="_blank">
    <b-icon-download variant="primary" font-scale="1.3"></b-icon-download>
  </a>
</template>

<script>
import imagePath from '@/filters/image-path';
import {
  BIconDownload,
} from 'bootstrap-vue';

export default {
  props: ['pdfSrc'],
  components: {
    BIconDownload,
  },
  filters: {
    imagePath,
  },
};
</script>

<style scoped lang="scss">
</style>
